<template>
    <div class="okraina-pbb" ref="root">
        <div class="nearest-expire" v-if="this.dataBonus.nearestExpire">
            <div class="sum">{{ this.dataBonus.nearestExpire.SUM }} {{ this.dataBonus.type == 'BONUS' ? 'баллов' : 'фишек' }}</div>
            <div> сгорят {{ this.dataBonus.nearestExpire.DATE }}, успейте потратить</div>
        </div>
    </div>
</template>
<script>


export default {
    name: "okraina-personal-bonus-burning",
    components: {},
    data() {
        return {};
    },
    props:{
        dataBonus: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    computed: {},
    watch: {},
    methods: {},
    created() {},

}

</script>

<style lang="scss">
.okraina-pbb {

    .nearest-expire {
        margin-top: 10px;
        margin-bottom: 0px;
        border-radius: 10px;
        border: 2px solid var(--color-color2);
        padding: 15px 25px;
        text-align: center;
        font-size: 16px;
        color: var(--color-color1);
        font-weight: 500;

        .sum {
            font-size: 20px;
        }
    }

}
</style>